import type { ReactNode } from 'react';

import type { LocalRecord, Task } from '../../shared/model';

import { pagePaths } from '../lib/routes';
import { TaskBadges } from './StatusBadge';
import { ButtonLink, PageHeader } from './ui';

export function TaskPage({
  record,
  records,
  controls,
  note,
}: {
  record?: LocalRecord;
  records: LocalRecord[];
  controls: ReactNode;
  note: ReactNode;
}) {
  if (!record) {
    return (
      <main className="productivity-page">
        <PageHeader
          title="Task not available"
          description="This task may have been removed or moved to trash. If you are offline, reconnect to retrieve tasks that are not on this device."
        />
        <ButtonLink variant="secondary" href={pagePaths.Tasks}>
          All tasks
        </ButtonLink>
      </main>
    );
  }

  const task = record.value as Task;

  return (
    <main className="task-detail-page">
      <header className="task-detail-heading">
        <ButtonLink variant="ghost" href={pagePaths.Tasks}>
          ← All tasks
        </ButtonLink>
        <PageHeader title={task.title}>
          <TaskBadges record={record} records={records} />
        </PageHeader>
      </header>
      <div className="workbench">
        <div className="task-detail-controls">{controls}</div>
        {note}
      </div>
    </main>
  );
}
